import CampaignPicturesApp from 'campaign/components/campaignDocuments/CampaignPicturesApp'
import React from 'react'

const HydrometryCampaignPicturesApp = () => (
    <CampaignPicturesApp stationType='hydrometry' />
)

export default HydrometryCampaignPicturesApp
